import React from 'react';
import {
	Box,
	IconButton, Link, Popover,
} from '@material-ui/core'
import PersonIcon from '@material-ui/icons/Person';
import SettingsIcon from '@material-ui/icons/Settings';

interface adminProps {
	handleLogout: () => void
}

const AdminBar = ({ handleLogout }: adminProps) => {
	const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const open = Boolean(anchorEl);
	const id = open ? 'simple-popover' : undefined;

	return (
		<>
			<IconButton onClick={handleClick} color="inherit"><PersonIcon /></IconButton>
			<IconButton color="inherit"><SettingsIcon /></IconButton>
			<Popover
				id={id}
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'center',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'center',
				}}
			>
				<Box p={2}>
					<Link href="#" underline="hover" onClick={handleLogout}>Logout</Link>
				</Box>
			</Popover>
		</>
	)
}

export default AdminBar;
